import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';

export interface SettingsPanelBodyContentSignature {
  Args: {
    style?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default class SpContent extends Component<SettingsPanelBodyContentSignature> {
  get style(): string {
    return this.args.style ?? 'inset';
  }

  <template>
    {{#if (eq this.style "inset")}}
      <div class="ml-16" ...attributes>
        {{yield}}
      </div>
    {{else if (eq this.style "full")}}
      <div class="mb-4 py-4" ...attributes>
        {{yield}}
      </div>
    {{else}}
      {{yield}}
    {{/if}}
  </template>
}
